export class ScrollService {
    public scrollToTop() {
        const elements = document.getElementsByClassName('content-wrapper');
        if (elements.length) elements[0].scrollTo(0, 0);
    }
}
